import { useState } from "react";
import useApi from "../../helpers/api";

export default function useActions(template) {
  const api = useApi();
  const [loading, setLoading] = useState(false);
  const updateTemplate = async ({html, css}) => {
    setLoading(true);
    template.html = html;
    template.css = css;
    await api.updateTemplate(template);
    setLoading(false)
  }

  return {
    updateTemplate,
    loading
  };
}
